export function getRetryOrderId(searchParams) {
  if (!searchParams?.get) {
    return null;
  }

  const value = searchParams.get("retry");
  if (value == null) {
    return null;
  }

  const trimmed = value.trim();
  return trimmed.length > 0 ? trimmed : null;
}

export function hasRetryOrderId(searchParams) {
  return getRetryOrderId(searchParams) != null;
}

/** OAE abandon emails carry retry=<externalOrderId> for tracking, not payment retry. */
export function isOaeReturnLink(searchParams) {
  return (
    searchParams?.get?.("externalPartnerId") === "OAE" &&
    searchParams?.get?.("paymentKo") !== "1"
  );
}

export function isOrderPagePaymentRetryMode(searchParams) {
  return hasRetryOrderId(searchParams) && !isOaeReturnLink(searchParams);
}

export function getPaymentRetryOrderId(searchParams) {
  return isOrderPagePaymentRetryMode(searchParams)
    ? getRetryOrderId(searchParams)
    : null;
}

export function stripInvalidRetryFromUrl(url = window.location.href) {
  const parsed = new URL(url);
  if (
    parsed.searchParams.has("retry") &&
    !getRetryOrderId(parsed.searchParams)
  ) {
    parsed.searchParams.delete("retry");
    return parsed.toString();
  }
  return url;
}

export function buildOrderPagePaymentKoUrl(
  origin,
  slug,
  orderId,
  extraParams = {},
) {
  const params = new URLSearchParams({ paymentKo: "1", ...extraParams });
  if (orderId) {
    params.set("retry", String(orderId));
  }
  const query = params.toString();
  return `${origin}/${slug}/${query ? `?${query}` : ""}`;
}

export function buildOrderPageRetryUrl(
  origin,
  slug,
  orderId,
  extraParams = {},
) {
  const params = new URLSearchParams(extraParams);
  params.set("retry", String(orderId));
  const query = params.toString();
  return `${origin}/${slug}/?${query}`;
}
